module.exports = __webpack_public_path__ + "static/media/elisabeth_polanski.636366f2.jpg";